export default class TextHighlighter {
    highlight(text, terms, cssClass) {
        const re = new RegExp(terms.join('|'), 'gi');

        return text.replace(re, (match) => {
            return `<span class="${cssClass}">${match}</span>`;
        });
    }
}



// WEBPACK FOOTER //
// ./js/marketing/utils/TextHighlighter.js